import { AbstractCameraRig } from "./AbstractCameraRig";
/**
 * Controls the camera rigging for the main scaling and centring to the screen.
 */
export class MainCameraRig extends AbstractCameraRig {
    handleResize(event) {
        super.handleResize(event);
        this.recentreFocus();
        const scale = this.renderer.isLandscape() ? this.getLandscapeScale() : this.getPortraitScale();
        this.scale.set(scale);
    }
    getLandscapeScale() {
        const x = (this.renderer.getWindowSize().x / this.renderer.getHolder().scale.x);
        const viewportWidth = this.renderer.getViewport().width;
        if (x < viewportWidth) {
            const minScale = 0.5;
            const scale = parseFloat(Math.max(minScale, x / viewportWidth).toFixed(2));
            return scale;
        }
        return 1;
    }
    getPortraitScale() {
        const y = (this.renderer.getWindowSize().y / this.renderer.getHolder().scale.y);
        const viewportHeight = this.renderer.getViewport().height;
        if (y < viewportHeight) {
            const minScale = 0.6;
            const scale = parseFloat(Math.max(minScale, y / viewportHeight).toFixed(2));
            return scale;
        }
        return 1;
    }
}
//# sourceMappingURL=MainCameraRig.js.map